import React from 'react';
import { motion } from 'framer-motion';
const reformerTomos = [{
  num: 1,
  title: 'Reformer Esencial',
  desc: 'El primer contacto con el Reformer. Footwork, core básico y activación de patrones fundamentales desde la primera sesión.'
}, {
  num: 2,
  title: 'Reformer Intermedio',
  desc: 'Control excéntrico, inestabilidad progresiva y trabajo de cadena anterior profunda. El nivel que más alumnos abandonan sin sistema.'
}, {
  num: 3,
  title: 'Reformer Avanzado',
  desc: 'Control máximo del carro, series invertidas, pliometría y secuencias sin pausa. Para el alumno que está listo para el siguiente nivel.'
}, {
  num: 4,
  title: 'Reformer Casos Especiales',
  desc: 'Tercera edad, lesiones, restaurativo y terapéutico. El tomo que te protege legalmente y profesionalmente con cada alumno especial.'
}, {
  num: 5,
  title: 'Reformer Fluidez & Coreografía',
  desc: 'Transiciones artísticas, musicalidad y clases que tus alumnos no olvidan. El tomo que te diferencia de cualquier otro instructor.'
}, {
  num: 6,
  title: 'Reformer Experto',
  desc: 'Programación avanzada, periodización y el sistema completo para instructores de nivel experto. Tu obra maestra en Reformer.'
}];
const matTomos = [{
  num: 7,
  title: 'Mat Esencial',
  desc: 'El método original de Joseph Pilates. Posturas base, respiración y confianza desde la primera clase en el suelo.'
}, {
  num: 8,
  title: 'Mat Intermedio (Clásico)',
  desc: 'El orden clásico completo con progresión real. Alineación, correcciones verbales y técnica de los ejercicios fundamentales del Mat.'
}, {
  num: 9,
  title: 'Mat Avanzado',
  desc: 'Teaser, Boomerang y Control Balance. Las series que tus alumnos más avanzados necesitan y tú puedes darles con seguridad.'
}, {
  num: 10,
  title: 'Mat Casos Especiales',
  desc: 'Tercera edad, post-parto, lesiones y restaurativo. Secuencias terapéuticas para los alumnos que más necesitan tu criterio profesional.'
}, {
  num: 11,
  title: 'Mat Fluidez & Coreografía',
  desc: 'Conexión movimiento-respiración en flujo continuo. La clase de Mat que tus alumnos van a querer repetir cada semana.'
}, {
  num: 12,
  title: 'Mat Experto',
  desc: 'Periodización anual, identidad del instructor y el sistema completo para enseñar Mat al más alto nivel profesional.'
}];
export const Product = () => {
  return <section className="py-20 bg-white" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        {/* Product Presentation */}
        <div className="text-center mb-20" data-id="element-186">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-brand-gold/20 text-brand-charcoal font-bold text-sm tracking-wide mb-6" data-id="element-187">
            🏆 El Sistema N°1 para Profesores de Pilates de habla hispana
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-188">
            PILATES 360 — Colección Completa
          </h2>
          <p className="text-2xl text-brand-terracotta font-serif italic mb-8" data-id="element-189">
            12 Tomos + 6 Bonus — Todo resuelto, todos los niveles.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-lg font-medium text-gray-700" data-id="element-190">
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-191">
              +280 páginas
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-192">
              +150 ejercicios graficados
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-193">
              Reformer + Mat
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-194">
              Todos los niveles
            </span>
          </div>
        </div>

        {/* Los 12 Tomos */}
        <div className="mb-16" data-id="element-195">
          <div className="text-center mb-12" data-id="element-196">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-197">
              Los 12 Tomos Completos
            </h3>
            <p className="text-xl text-gray-600" data-id="element-198">
              Sesiones graficadas · Por nivel y objetivo · Listo para usar
              mañana
            </p>
          </div>

          {/* Reformer Series */}
          <div className="mb-16" data-id="element-199">
            <div className="flex items-center gap-4 mb-8" data-id="element-200">
              <div className="h-px bg-brand-sand flex-1" data-id="element-201"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-202">
                SERIE REFORMER
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-203"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204">
              {reformerTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-205">
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-206">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-207">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-208">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Mat Series */}
          <div data-id="element-209">
            <div className="flex items-center gap-4 mb-8" data-id="element-210">
              <div className="h-px bg-brand-sand flex-1" data-id="element-211"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-212">
                SERIE MAT
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-213"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-214">
              {matTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-215">
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-216">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-217">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-218">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Features Footer */}
        <div className="bg-brand-charcoal text-white rounded-2xl p-8 text-center max-w-4xl mx-auto" data-id="element-219">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6" data-id="element-220">
            <div className="font-medium" data-id="element-221">
              ✏️ Ejercicios graficados en cada tomo
            </div>
            <div className="font-medium" data-id="element-222">⚡ Sistema "Abre y Da clase"</div>
            <div className="font-medium" data-id="element-223">📋 Fichas listas para imprimir</div>
            <div className="font-medium" data-id="element-224">
              🌎 Contenido para todo el mundo hispanohablante
            </div>
          </div>
        </div>
      </div>
    </section>;
};